import { store } from '@/store'
import { companyApi } from '@/store/services'
import { redirect } from 'react-router-dom'
import { list } from '../utils'

export const CompanyEditAction = async (args) => {
  const { request } = args
  const params = await request.json()
  const method = request.method

  try {
    await store
      .dispatch(
        companyApi.endpoints.updateCompany.initiate(params)
      )
      .unwrap()
    if (method === 'PUT') return redirect(list('companies'))

    return null
  } catch (error) {
    return error
  }
}

export const CompanyCreateAction = async (args) => {
  const { request } = args
  const params = await request.json()

  try {
    await store
      .dispatch(
        companyApi.endpoints.createCompany.initiate(params)
      )
      .unwrap()
    return redirect(list('companies'))
  } catch (error) {
    return error
  }
}
